import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useQuery } from 'react-query'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'

export const SubmittedByProvider: React.FC<IProviderProps> = ({ render }) => {
  const { data, isFetching } = useQuery(
    ['filters', 'draftLeads', 'submittedBy'],
    async (): Promise<IOption[]> => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}${ServiceConfig.filters(
          'draftLeads',
          'UserName',
        )}`,
      )

      const userNames: string[] = await result.json()

      const options: IOption[] = userNames
        .filter((v) => !!v && v !== '')
        .sort((a, b) => a.localeCompare(b))
        .map((v) => ({
          value: v,
          label: v,
        }))

      return options
    },
  )

  return <>{render(data ?? [], isFetching)}</>
}
SubmittedByProvider.displayName = 'SubmittedByProvider'
